<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/currencyExchangeList" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("system.label.viewCurrencyExchange") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("system.label.baseCurrency") }}</b>
                </td>
                <td>{{ countrycurrencyData.baseCurrency }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.conversionCurrency") }}</b>
                </td>
                <td>{{ countrycurrencyData.currency }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.conversionRate") }}</b>
                </td>
                <td>{{ countrycurrencyData.conversionRate }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.status") }}</b>
                </td>
                <td>{{ countrycurrencyData.status }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.validFrom") }}</b>
                </td>
                <td>{{ countrycurrencyData.validFrom | formatedate }}</td>
              </tr>
              <tr>
                <td class="border-none">
                  <b>{{ $t("system.label.validTo") }}</b>
                </td>
                <td class="border-none">
                  {{ countrycurrencyData.validTo | formatedate }}
                </td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      countrycurrencyData: {},
    };
  },

  computed: {
    breadcrumbs() {
      return [
        {
          name: this.$t("reports.label.currencyMaster"),
          to: "/currencyconfig",
        },
        { name: this.$t("system.label.viewCurrencyExchange"), to: "/" },
      ];
    },
  },
  methods: {
    async getCountryCurrencyById() {
      try {
        const response = await this.$store.dispatch(
          "currencyExchange/fetchApnZoneIdAction",
          this.id
        );
        this.countrycurrencyData = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY");
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getCountryCurrencyById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
